import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-913b2ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-name" }
const _hoisted_2 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_oio_form = _resolveComponent("oio-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oio_form, { data: _ctx.data }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (groupData, groupName, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(groupName), 1),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupData, (attrItem, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 12,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_oio_form_item, {
                          label: attrItem.name + ':',
                          style: {"width":"400px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.attrFormatter(attrItem)), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}